import React from 'react'
import _ from 'lodash'
import { Dialog } from "@blueprintjs/core";
import AppState from "../../state/AppState";
import {LoginForm} from '../forms'

class CancelSubscriptionDialog extends React.Component {

  constructor(props) {
    super(props);

    this.state = {processing: false, showErrors: false}
  }

  render() {

    const { onClose = _.noop, isOpen = false, undo = false } = this.props;
    const { showErrors = false, processing } = this.state;

    return (
      <div className="LoginDialog">
        <Dialog isOpen={isOpen}
                onClose={() => onClose() }
                title="Login">
          <div className="pt-dialog-body">
            <LoginForm onSuccess={(user) => this.onLogin(user)}/>
          </div>
        </Dialog>
      </div>
    )
  }

  onLogin() {

  }
}

export default AppState.connect(React, CancelSubscriptionDialog);



// WEBPACK FOOTER //
// ./src/components/user/LoginDialog.js